import { useContext } from "react"
import { useLocation } from "react-router-dom"
import { ServerRenderedProps } from "source/shared/contexts/ServerRenderedProps"
import ConfirmationLayout from "../../components/ConfirmationLayout"
import { PostDonateStatus } from "../form/components/PostDonateStatus"

export function DonationProcessing() {
  const {
    current_person: {
      data: {
        attributes: { first_name },
      },
    },
  } = useContext(ServerRenderedProps)

  const {
    state: { nondeterministicError },
  } = useLocation()

  const { heading, message } = nondeterministicError
    ? {
        heading: "Donation processing",
        message:
          "Your donation has been received, and we’ll email a receipt when processing is complete.",
      }
    : {
        heading: `Thank you, ${first_name}!`,
        message:
          "Your donation is processing, and we’ll email a receipt for your records.",
      }

  return (
    <ConfirmationLayout>
      <PostDonateStatus
        status="processing"
        heading={heading}
        message={message}
      />
    </ConfirmationLayout>
  )
}
